export enum CastTech {
  AirPlay = 'AirPlay',
  GoogleCast = 'GoogleCast',
  WebSocket = 'WebSocket',
}
